module.exports = require("striptags");